module.exports = __webpack_public_path__ + "static/media/service-business-hall.7324e90a.jpg";